import { render } from "./FreeAgent.vue?vue&type=template&id=fa2ab0d0&scoped=true"
import script from "./FreeAgent.vue?vue&type=script&lang=js"
export * from "./FreeAgent.vue?vue&type=script&lang=js"

import "./FreeAgent.vue?vue&type=style&index=0&id=fa2ab0d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa2ab0d0"]])

export default __exports__